<p-dialog (onHide)="closeImportDialog()"
          (visibleChange)="closeImportDialog()"
          [closable]="true"
          [modal]="true"
          [visible]="visible()"
          id="importDialog"
          styleClass="w-full sm:w-4/5 md:w-2/3 lg:w-1/2 xl:w-2/5">

  <ng-template #header>
    <div class="flex flex-col">
      <div class="header-title-dialog">Importar Arquivo</div>
    </div>
  </ng-template>

  <ng-content>
    <p-fluid>
      <form [formGroup]="importForm">
        <div class="flex flex-col gap-4">
          <div class="flex flex-col justify-start gap-2">
            <label for="tipoArquivo">Tipo do Arquivo</label>
            <p-select [options]="tipoArquivoOptions"
                      appendTo="body"
                      formControlName="tipoArquivo"
                      id="tipoArquivo"
            ></p-select>
          </div>
          <p-button (click)="downloadModelo()" [disabled]="disabledButtonBaixarModelo"
                    class="w-full xs:w-1/2 sm:w-1/2 md:w-1/2 "
                    id="buttonBaixarModelo"
                    label="Baixar Modelo"
                    styleClass="btn-outlined">
            <app-icon-document-download color="currentColor"></app-icon-document-download>
          </p-button>
          <div class="flex flex-col justify-start gap-2">
            <div class="flex flex-col gap-2">
              <label for="fileUpload">Arquivo:</label>
              <div class="flex w-full items-center gap-2">

                @if (uploadedFiles.length > 0) {
                  <div class="w-full flex flex-col gap-2 p-2 align-center bg-gray-200 rounded-lg">
                    @for (file of uploadedFiles; track $index) {
                      <div class="flex items-center gap-4">
                        <app-icon-exportar-excel color="currentColor"/>
                        <div class="flex flex-row justify-between items-center w-full">
                          <div class="break-words">
                            {{ file.name }}
                          </div>
                          <p-button
                            (click)="onRemoveFile($index)"
                            pTooltip="Remover"
                            styleClass="btn-icon"
                            tooltipPosition="bottom">
                            <app-icon-trash color="var(--color-primary)"/>
                          </p-button>
                        </div>
                      </div>
                    }
                  </div>
                } @else {
                  <p-fileupload id="fileUpload"
                                (onSelect)="onSelectFileUpload($event)"
                                [multiple]="false"
                                [showCancelButton]=false
                                [showUploadButton]="false"
                                class="w-full"
                                accept=".xlsx"
                                chooseLabel="Selecione"
                                chooseStyleClass="btn-red"
                                styleClass="!flex !flex-row !items-center !justify-between"
                                name="fileInput">
                    <ng-template pTemplate="content">
                      @if (!fileTooLarge && !fileInvalidExtension) {
                        <ng-container>
                          ou arraste o arquivo aqui
                        </ng-container>
                      } @else if (fileTooLarge) {
                        <span
                          class="text-[#E41B2E]">Tamanho de arquivo não permitido. Máx:  {{ getFormattedMaxSize() }}</span>
                      } @else {
                        <span
                          class="text-[#E41B2E]">Extensões permitidas: .{{ allowedExtensions.join(', .') }}</span>
                      }
                    </ng-template>

                    <ng-template pTemplate="file"></ng-template>
                  </p-fileupload>
                }

              </div>

            </div>
          </div>
        </div>
      </form>
    </p-fluid>
  </ng-content>

  <ng-template #footer>
    <p-button (click)="closeImportDialog()" label="Cancelar" styleClass="btn-outlined">
      <app-icon-close-square color="currentColor"/>
    </p-button>
    <p-button (click)="import()" [loading]="loading"
              label="Importar"
              styleClass="btn-red">
      @if (!loading) {
        <app-icon-import color="currentColor"/>
      }
    </p-button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="showFailImportDialog"
          [closable]="true"
          [modal]="true"
          id="failImportDialog">
  <ng-template #header>
    <div class="flex flex-col">
      <div class="header-title-dialog">Importação Falhou</div>
    </div>
  </ng-template>

  <ng-content>
    <div class="flex flex-col gap-4">

      <!-- Caso seja um erro genérico (400 ou outro) -->
      @if (genericErrorMessage) {
        <p>{{ genericErrorMessage }}</p>
      }

      <!-- Caso seja um erro de validação (422) -->
      @if (validationErrorImport.length > 0) {
        <div class="flex flex-col items-center gap-2">
          <p>Alguns campos obrigatórios não foram preenchidos no arquivo selecionado:</p>
        </div>
        <p-card class="overflow-x-auto">
          <p-table [value]="validationErrorImport">
            <ng-template pTemplate="header">
              <tr>
                <th>Linha do arquivo</th>
                <th>Coluna com erro</th>
                <th>Descrição do erro</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-error>
              <tr>
                <td>{{ error.rowNumber }}</td>
                <td>{{ error.columnName }}</td>
                <td>{{ error.message }}</td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      }
    </div>
  </ng-content>

  <ng-template #footer>
    <p-button (click)="closeFailImportDialog()" label="Fechar" styleClass="btn-transparent"></p-button>
  </ng-template>
</p-dialog>

@if (loading) {
  <div
    class="fixed inset-0 flex items-center justify-center z-[9999] bg-black/40">
    <p-progress-spinner
      ariaLabel="loading"
      [style]="{
        '--p-progressspinner-color-one':  '#E41B2E',
    '--p-progressspinner-color-two':  '#000',
    '--p-progressspinner-color-three':'#E41B2E',
    '--p-progressspinner-color-four': '#000',
        width: '50px', height: '50px' }"
    ></p-progress-spinner>
  </div>
}
